/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListApprovalCompetenciesResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'ApprovalCompetency',
        },
      },
    },
  }],
} as const;
